import { SVGProps } from 'react'

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
  checkmarkColor?: string
  checked?: boolean
}

const LocationIcon = ({ size = 16, color = '#666666', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_2301_258)">
      <path
        d="M8 0C6.4087 0 4.88258 0.589998 3.75736 1.6402C2.63214 2.69041 2 4.11479 2 5.6C2 9.8 8 16 8 16C8 16 14 9.8 14 5.6C14 4.11479 13.3679 2.69041 12.2426 1.6402C11.1174 0.589998 9.5913 0 8 0ZM8 7.6C7.57618 7.6 7.16188 7.4827 6.80949 7.26294C6.4571 7.04318 6.18245 6.73082 6.02026 6.36537C5.85807 5.99992 5.81564 5.59778 5.89832 5.20982C5.981 4.82186 6.18509 4.46549 6.48477 4.18579C6.78446 3.90608 7.16628 3.7156 7.58195 3.63843C7.99762 3.56126 8.42848 3.60087 8.82004 3.75224C9.21159 3.90362 9.54626 4.15996 9.78172 4.48886C10.0172 4.81776 10.1429 5.20444 10.1429 5.6C10.1425 6.13034 9.91666 6.63887 9.51487 7.01388C9.11308 7.38889 8.56822 7.5997 8 7.6Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2301_258">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const ArrowDown = ({ size = 16, color = '#000', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.00197 9.36205L12.539 4.82306C12.6183 4.74326 12.7127 4.67995 12.8166 4.63674C12.9205 4.59353 13.0319 4.57129 13.1445 4.57129C13.257 4.57129 13.3684 4.59353 13.4724 4.63674C13.5763 4.67995 13.6706 4.74326 13.75 4.82306C13.9097 4.98493 13.9992 5.20317 13.9992 5.43056C13.9992 5.65794 13.9097 5.87619 13.75 6.03806L8.60897 11.1831C8.45293 11.3387 8.24285 11.4282 8.02249 11.4329C7.80212 11.4375 7.58845 11.357 7.42597 11.2081L2.24897 6.04205C2.08732 5.88133 1.99614 5.66298 1.99548 5.43503C1.99483 5.20708 2.08475 4.9882 2.24547 4.82655C2.40619 4.66491 2.62455 4.57372 2.8525 4.57307C3.08045 4.57241 3.29932 4.66233 3.46097 4.82305L8.00197 9.36205Z"
      fill={color}
    />
  </svg>
)

const CutleryIcon = ({ size = 16, color = '#45BF59', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.42409 5.66667C7.42409 3.0895 6.20857 1 4.71144 1C3.21431 1 2 3.0895 2 5.66667C2.00044 6.19932 2.16839 6.71919 2.48147 7.15693C2.79454 7.59467 3.23785 7.92946 3.75227 8.11667L3.51157 13.8333C3.51157 14.1428 3.63837 14.4395 3.86406 14.6583C4.08976 14.8771 4.39587 15 4.71505 15C5.03424 15 5.34034 14.8771 5.56604 14.6583C5.79174 14.4395 5.91853 14.1428 5.91853 13.8333L5.67784 8.11667C6.19113 7.92852 6.63315 7.59332 6.94509 7.15566C7.25703 6.718 7.42411 6.19864 7.42409 5.66667Z"
      fill="#45BF59"
    />
    <path
      d="M13.9998 5.22917L13.8493 1H13.0899L12.9395 5.22917H12.3378L12.1922 1H11.2847L11.1343 5.22917H10.5325L10.3833 1H9.62993L9.47949 5.22917C9.48001 5.65147 9.60683 6.06457 9.84456 6.41844C10.0823 6.77231 10.4208 7.05178 10.819 7.223L10.5337 13.8333C10.5337 14.1428 10.6605 14.4395 10.8862 14.6583C11.1119 14.8771 11.418 15 11.7372 15C12.0564 15 12.3625 14.8771 12.5882 14.6583C12.8139 14.4395 12.9407 14.1428 12.9407 13.8333L12.6555 7.223C13.0546 7.05247 13.3941 6.7733 13.6327 6.41938C13.8713 6.06545 13.9988 5.65198 13.9998 5.22917Z"
      fill={color}
    />
  </svg>
)

const PlaneIcon = ({ size = 16, color = '#666666', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.6047 1.39554C14.0696 0.860469 13.1993 0.869411 12.6754 1.41539L9.80735 4.40403L2.8083 2.08779L1.33907 3.55705L7.17301 7.14912L4.22104 10.2252L2.32797 9.91438L1 11.2424L3.78309 12.2171L4.75789 15.0002L6.08586 13.6723L5.77507 11.7792L8.85113 8.82726L12.4432 14.6612L13.9125 13.1919L11.5962 6.19286L14.5848 3.32487C15.1308 2.8009 15.1398 1.93064 14.6047 1.39554Z"
      fill={color}
    />
  </svg>
)

const BedIcon = ({ size = 16, color = '#666666', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2.64062 8.82031V3.07812H1V12.9219H2.64062V11.2812H13.3594V12.9219H15V11.2812V8.82031H2.64062Z"
      fill="#666666"
    />
    <path
      d="M4.69141 5.53906C4.01183 5.53906 3.46094 6.08996 3.46094 6.76953V8H5.92188V6.76953C5.92188 6.08996 5.37098 5.53906 4.69141 5.53906Z"
      fill="#666666"
    />
    <path
      d="M13.7695 5.53906H7.97266C7.29308 5.53906 6.74219 6.08996 6.74219 6.76953V8H15V6.76953C15 6.08996 14.4491 5.53906 13.7695 5.53906Z"
      fill={color}
    />
  </svg>
)

const CheckmarkCircle = ({
  size = 16,
  color = '#45BF59',
  checkmarkColor = '#FFF',
  ...rest
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_2332_6420)">
      <path
        d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16Z"
        fill={color}
      />
      <path
        d="M7.21683 10.8489L4.61683 8.24895C4.57964 8.2118 4.55013 8.16768 4.53 8.11912C4.50987 8.07057 4.49951 8.01851 4.49951 7.96595C4.49951 7.91338 4.50987 7.86133 4.53 7.81277C4.55013 7.76421 4.57964 7.7201 4.61683 7.68295L5.18283 7.11695C5.21998 7.07976 5.26409 7.05025 5.31265 7.03012C5.36121 7.00999 5.41326 6.99963 5.46583 6.99963C5.51839 6.99963 5.57044 7.00999 5.619 7.03012C5.66756 7.05025 5.71168 7.07976 5.74883 7.11695L7.49983 8.86895L11.2508 5.11695C11.288 5.07976 11.3321 5.05025 11.3807 5.03012C11.4292 5.00999 11.4813 4.99963 11.5338 4.99963C11.5864 4.99963 11.6384 5.00999 11.687 5.03012C11.7356 5.05025 11.7797 5.07976 11.8168 5.11695L12.3828 5.68295C12.42 5.7201 12.4495 5.76421 12.4697 5.81277C12.4898 5.86133 12.5001 5.91338 12.5001 5.96595C12.5001 6.01851 12.4898 6.07057 12.4697 6.11912C12.4495 6.16768 12.42 6.2118 12.3828 6.24895L7.78283 10.8489C7.74568 10.8861 7.70156 10.9156 7.653 10.9358C7.60444 10.9559 7.55239 10.9663 7.49983 10.9663C7.44726 10.9663 7.39521 10.9559 7.34665 10.9358C7.29809 10.9156 7.25398 10.8861 7.21683 10.8489Z"
        fill={checkmarkColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_2332_6420">
        <rect width="16" height="16" fill={checkmarkColor} transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

const PlayIconRounded = ({
  size = 41,
  color = '#10C9BA',
  ...rest
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.457 40.2032C31.5026 40.2032 40.457 31.2075 40.457 20.1109C40.457 9.01419 31.5026 0.0185547 20.457 0.0185547C9.41133 0.0185547 0.457031 9.01419 0.457031 20.1109C0.457031 31.2075 9.41133 40.2032 20.457 40.2032ZM17.844 27.838L27.2844 22.2387C28.8478 21.3112 28.8478 18.9106 27.2844 17.9831L17.844 12.3838C16.3244 11.4825 14.457 12.6556 14.457 14.5115V25.7102C14.457 27.5662 16.3244 28.7393 17.844 27.838Z"
      fill="#10C9BA"
    />
  </svg>
)

const CloseIcon = ({ size = 16, color = '#FFF', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.88393 8.00002L15.8169 1.06697C16.061 0.822881 16.061 0.427132 15.8169 0.18307C15.5729 -0.0609921 15.1771 -0.0610233 14.933 0.18307L7.99999 7.11612L1.06697 0.18307C0.822881 -0.0610233 0.427132 -0.0610233 0.18307 0.18307C-0.0609921 0.427163 -0.0610233 0.822912 0.18307 1.06697L7.11609 7.99999L0.18307 14.933C-0.0610233 15.1771 -0.0610233 15.5729 0.18307 15.8169C0.305101 15.939 0.465069 16 0.625038 16C0.785006 16 0.944944 15.939 1.06701 15.8169L7.99999 8.88393L14.933 15.8169C15.055 15.939 15.215 16 15.375 16C15.5349 16 15.6949 15.939 15.8169 15.8169C16.061 15.5729 16.061 15.1771 15.8169 14.933L8.88393 8.00002Z"
      fill={color}
    />
  </svg>
)

const Arrow = ({ size = 12, color = '#FFF', rotate = 0, ...rest }: IconProps) => (
  <svg
    width={size}
    height={size / 0.75}
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{transform: `rotate(${rotate}deg)`}}
    {...rest}
  >
    <path
      d="M0.906249 2.19788L6.70837 8L0.90625 13.8021L3.10413 16L11.1041 8L3.10413 -9.60722e-08L0.906249 2.19788Z"
      fill={color}
    />
  </svg>
)

const BookIcon = ({ size = 12, color = '#45BF59', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size / 1.14}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2.44794 0.888168C2.44751 0.888168 2.44703 0.888168 2.4466 0.888168C2.29527 0.888168 2.15294 0.947158 2.04547 1.05436C1.93681 1.16276 1.87695 1.30708 1.87695 1.46072V10.0461C1.87695 10.3609 2.13409 10.6177 2.45021 10.6185C3.7829 10.6216 6.01569 10.8994 7.556 12.5113V3.52651C7.556 3.41979 7.52874 3.31953 7.4773 3.23657C6.21308 1.20063 3.78365 0.891293 2.44794 0.888168Z"
      fill={color}
    />
    <path
      d="M14.1243 10.0461V1.46067C14.1243 1.30703 14.0645 1.1627 13.9558 1.05431C13.8483 0.947105 13.7059 0.888115 13.5547 0.888115C13.5542 0.888115 13.5537 0.888115 13.5533 0.888115C12.2177 0.891293 9.78824 1.20063 8.52397 3.23657C8.47252 3.31953 8.44531 3.41979 8.44531 3.52651V12.5113C9.98563 10.8994 12.2184 10.6216 13.5511 10.6184C13.8672 10.6176 14.1243 10.3608 14.1243 10.0461Z"
      fill={color}
    />
    <path
      d="M15.4277 2.86808H15.0126V10.0461C15.0126 10.8499 14.3577 11.5054 13.5526 11.5074C12.4222 11.51 10.5583 11.7311 9.23828 12.9804C11.5213 12.4215 13.928 12.7848 15.2996 13.0974C15.4708 13.1364 15.6478 13.0961 15.785 12.9867C15.9217 12.8776 16.0002 12.7146 16.0002 12.5395V3.44053C16.0002 3.12489 15.7434 2.86808 15.4277 2.86808Z"
      fill={color}
    />
    <path
      d="M0.987586 10.0461V2.86808H0.572446C0.256863 2.86808 0 3.12489 0 3.44053V12.5394C0 12.7145 0.078438 12.8775 0.215166 12.9866C0.352271 13.0959 0.529079 13.1363 0.700608 13.0972C2.0722 12.7846 4.47894 12.4213 6.76183 12.9803C5.44185 11.731 3.57798 11.51 2.44758 11.5073C1.64256 11.5054 0.987586 10.8499 0.987586 10.0461Z"
      fill={color}
    />
  </svg>
)

const OpenBookIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.44794 1.88806C2.44751 1.88806 2.44703 1.88806 2.4466 1.88806C2.29527 1.88806 2.15294 1.94705 2.04547 2.05426C1.93681 2.16265 1.87695 2.30697 1.87695 2.46062V11.046C1.87695 11.3608 2.13409 11.6176 2.45021 11.6184C3.7829 11.6215 6.01569 11.8993 7.556 13.5112V4.5264C7.556 4.41968 7.52874 4.31942 7.4773 4.23646C6.21308 2.20052 3.78365 1.89119 2.44794 1.88806Z"
      fill="#45BF59"
    />
    <path
      d="M14.1243 11.046V2.46062C14.1243 2.30697 14.0645 2.16265 13.9558 2.05426C13.8483 1.94705 13.7059 1.88806 13.5547 1.88806C13.5542 1.88806 13.5537 1.88806 13.5533 1.88806C12.2177 1.89124 9.78824 2.20057 8.52397 4.23651C8.47252 4.31948 8.44531 4.41973 8.44531 4.52645V13.5112C9.98563 11.8993 12.2184 11.6215 13.5511 11.6184C13.8672 11.6175 14.1243 11.3608 14.1243 11.046Z"
      fill="#45BF59"
    />
    <path
      d="M15.4277 3.86804H15.0126V11.046C15.0126 11.8499 14.3577 12.5053 13.5526 12.5073C12.4222 12.51 10.5583 12.731 9.23828 13.9804C11.5213 13.4214 13.928 13.7848 15.2996 14.0974C15.4708 14.1364 15.6478 14.0961 15.785 13.9867C15.9217 13.8776 16.0002 13.7145 16.0002 13.5395V4.44049C16.0002 4.12485 15.7434 3.86804 15.4277 3.86804Z"
      fill="#45BF59"
    />
    <path
      d="M0.987586 11.046V3.86804H0.572446C0.256863 3.86804 0 4.12485 0 4.44049V13.5393C0 13.7144 0.078438 13.8775 0.215166 13.9865C0.352271 14.0958 0.529079 14.1363 0.700608 14.0972C2.0722 13.7846 4.47894 13.4213 6.76183 13.9802C5.44185 12.7309 3.57798 12.51 2.44758 12.5073C1.64256 12.5053 0.987586 11.8499 0.987586 11.046Z"
      fill="#45BF59"
    />
  </svg>
)

const EmailIcon = ({ size = 16, color = '#999999', ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_2946_8718)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.06707 2C1.20669 2 0.5 2.68515 0.5 3.5335V12.4665C0.5 13.3119 1.20345 14 2.06707 14H14.9329C15.7911 14 16.5 13.3172 16.5 12.4665V3.5335C16.5 2.68813 15.7965 2 14.9329 2H2.06707ZM8.5285 8.88527L2.74016 3.2804H14.2672L8.5285 8.88527ZM1.80488 11.8193V4.17363L5.73589 7.98002L1.80488 11.8193ZM15.1951 11.8193L11.2846 8L15.1951 4.18067V11.8193ZM2.73277 12.7196L6.6647 8.87938L8.07224 10.2423C8.32703 10.489 8.73698 10.4882 8.99077 10.2403L8.99078 10.2403L10.3598 8.90327L14.2672 12.7196H2.73277Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2946_8718">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

const Checkbox = ({ checked }: IconProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.5"
      cy="12"
      r="11.5"
      fill="white"
      stroke={checked ? '#10C9BA' : '#E5E5E5'}
      strokeWidth="1"
    />
    <circle cx="12.5" cy="12" r="8" fill={checked ? '#10C9BA' : '#fff'} />
  </svg>
)

const ChatBubbleIcon = ({ size = 16, ...rest }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M8.00182 0C3.58281 0 0 3.32075 0 7.41768C0.00861092 8.54814 0.282866 9.66074 0.80063 10.6657C1.3184 11.6706 2.06517 12.5398 2.98068 13.203L3.01268 15.8176C3.01331 15.8498 3.02232 15.8814 3.03881 15.9091C3.05531 15.9368 3.07872 15.9598 3.10676 15.9757C3.13481 15.9916 3.16651 16 3.19877 16C3.23102 16 3.26272 15.9916 3.29075 15.9756L5.78932 14.5573C6.51124 14.7483 7.25507 14.8438 8.00182 14.8414C12.4208 14.8414 16.0036 11.5206 16.0036 7.42369C16.0036 3.32676 12.4208 0 8.00182 0ZM8.60195 9.80223L6.89156 8.02182C6.8425 7.97118 6.77826 7.93792 6.70858 7.92709C6.63891 7.91626 6.5676 7.92845 6.50548 7.96181L3.5048 9.57817C3.48081 9.58953 3.45366 9.59232 3.42787 9.58609C3.40208 9.57985 3.37921 9.56496 3.36306 9.5439C3.34692 9.52285 3.33848 9.49689 3.33915 9.47036C3.33983 9.44384 3.34957 9.41835 3.36677 9.39813L6.92157 5.65128C6.94553 5.62566 6.97449 5.60524 7.00666 5.59127C7.03884 5.57731 7.07354 5.5701 7.10862 5.5701C7.14369 5.5701 7.17839 5.57731 7.21057 5.59127C7.24274 5.60524 7.2717 5.62566 7.29566 5.65128L9.00204 7.46569C9.05082 7.51741 9.11533 7.55154 9.18553 7.56276C9.25573 7.57398 9.32767 7.56165 9.39013 7.52771L12.3408 5.92735C12.3648 5.91254 12.3935 5.90718 12.4213 5.9123C12.449 5.91742 12.4739 5.93266 12.4911 5.95506C12.5083 5.97746 12.5165 6.00544 12.5143 6.03358C12.512 6.06172 12.4994 6.08802 12.4788 6.10739L8.98204 9.81223C8.95817 9.83894 8.92897 9.86035 8.89631 9.87507C8.86365 9.88979 8.82826 9.89749 8.79244 9.89768C8.75662 9.89787 8.72116 9.89054 8.68834 9.87616C8.65553 9.86179 8.6261 9.84069 8.60195 9.81423V9.80223Z" fill="white"/>
  </svg>
)

const RewindIcon = ({size = 32, ...rest}: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path fillRule="evenodd" clipRule="evenodd" d="M20.19 0.559798C17.0435 -0.294555 13.711 -0.167223 10.6389 0.924745C7.56668 2.01671 4.90145 4.02119 3 6.6698V3.4998C3 3.10197 2.84196 2.72044 2.56066 2.43914C2.27936 2.15783 1.89782 1.9998 1.5 1.9998C1.10218 1.9998 0.720644 2.15783 0.43934 2.43914C0.158035 2.72044 0 3.10197 0 3.4998L0 11.9998H8.5C8.89782 11.9998 9.27936 11.8418 9.56066 11.5605C9.84196 11.2792 10 10.8976 10 10.4998C10 10.102 9.84196 9.72044 9.56066 9.43914C9.27936 9.15783 8.89782 8.9998 8.5 8.9998H5.046C6.61266 6.54877 8.95612 4.69402 11.7015 3.73226C14.4468 2.7705 17.4354 2.7573 20.1892 3.69479C22.9429 4.63227 25.3026 6.46626 26.8909 8.90335C28.4791 11.3404 29.2041 14.2398 28.9498 17.1376C28.6955 20.0354 27.4766 22.7642 25.4882 24.8874C23.4998 27.0107 20.8567 28.4056 17.9818 28.8492C15.1068 29.2927 12.1662 28.7592 9.63032 27.334C7.09443 25.9088 5.10983 23.6742 3.994 20.9878C3.83557 20.6293 3.5431 20.347 3.1792 20.2014C2.81529 20.0559 2.40885 20.0585 2.04686 20.2088C1.68486 20.359 1.39607 20.6451 1.24228 21.0056C1.0885 21.3661 1.08194 21.7725 1.224 22.1378C2.26638 24.6469 3.93054 26.8492 6.05959 28.5371C8.18865 30.225 10.7125 31.343 13.3932 31.7856C16.0738 32.2282 18.8231 31.9809 21.3817 31.0669C23.9404 30.153 26.2242 28.6025 28.0178 26.5617C29.8114 24.5209 31.0558 22.0569 31.6336 19.4021C32.2114 16.7473 32.1037 13.989 31.3205 11.3874C30.5374 8.78572 29.1046 6.42634 27.1572 4.53165C25.2099 2.63696 22.8121 1.27137 20.19 0.559798Z" fill="white"/>
  </svg>

)

const CloseCirlce = ({size = 16, ...rest}: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g clipPath="url(#clip0_3551_1936)">
    <path d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM10.027 10.9L8 8.873L5.973 10.896C5.91685 10.957 5.84895 11.006 5.77338 11.0401C5.69781 11.0742 5.61613 11.0926 5.53325 11.0943C5.45037 11.096 5.36799 11.081 5.29108 11.05C5.21417 11.0191 5.1443 10.9729 5.08568 10.9143C5.02706 10.8557 4.9809 10.7858 4.94997 10.7089C4.91903 10.632 4.90397 10.5496 4.90568 10.4668C4.90739 10.3839 4.92585 10.3022 4.95993 10.2266C4.99401 10.151 5.04302 10.0831 5.104 10.027L7.131 8L5.104 5.973C4.99651 5.85624 4.93831 5.70243 4.94159 5.54376C4.94486 5.38508 5.00936 5.23381 5.12158 5.12158C5.23381 5.00935 5.38508 4.94486 5.54376 4.94158C5.70244 4.93831 5.85624 4.9965 5.973 5.104L8 7.131L10.025 5.104C10.1418 4.9965 10.2956 4.93831 10.4542 4.94158C10.6129 4.94486 10.7642 5.00935 10.8764 5.12158C10.9886 5.23381 11.0531 5.38508 11.0564 5.54376C11.0597 5.70243 11.0015 5.85624 10.894 5.973L8.867 8L10.896 10.025C11.0104 10.1407 11.0745 10.2968 11.0745 10.4595C11.0745 10.6222 11.0104 10.7783 10.896 10.894C10.8393 10.9519 10.7716 10.998 10.6969 11.0294C10.6222 11.0609 10.542 11.0773 10.4609 11.0774C10.3799 11.0776 10.2996 11.0617 10.2247 11.0305C10.1499 10.9994 10.082 10.9536 10.025 10.896L10.027 10.9Z" fill="#CCCCCC"/>
    </g>
    <defs>
    <clipPath id="clip0_3551_1936">
    <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)

const CloseIconStroke = ({ size = 32, ...rest }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g clipPath="url(#clip0_4141_2563)">
    <path d="M17.897 15.9999L23.6113 10.2856C23.8528 10.0325 23.9856 9.69503 23.9815 9.34527C23.9774 8.99551 23.8366 8.66124 23.5893 8.4139C23.342 8.16657 23.0077 8.0258 22.6579 8.02169C22.3082 8.01757 21.9707 8.15044 21.7176 8.39189L16.0033 14.1062L10.289 8.39189C10.1658 8.26271 10.0179 8.15947 9.85422 8.08824C9.69049 8.01702 9.51418 7.97924 9.33565 7.97714C9.15711 7.97504 8.97996 8.00866 8.8146 8.07602C8.64925 8.14337 8.49903 8.24311 8.37278 8.36936C8.24653 8.49561 8.14679 8.64583 8.07944 8.81119C8.01208 8.97654 7.97846 9.15369 7.98056 9.33223C7.98266 9.51076 8.02043 9.68708 8.09166 9.8508C8.16289 10.0145 8.26613 10.1624 8.39531 10.2856L14.1096 15.9999L8.39531 21.7142C8.26613 21.8374 8.16289 21.9853 8.09166 22.149C8.02043 22.3127 7.98266 22.489 7.98056 22.6676C7.97846 22.8461 8.01208 23.0232 8.07944 23.1886C8.14679 23.354 8.24653 23.5042 8.37278 23.6304C8.49903 23.7567 8.64925 23.8564 8.8146 23.9238C8.97996 23.9911 9.15711 24.0247 9.33565 24.0226C9.51418 24.0205 9.69049 23.9828 9.85422 23.9115C10.0179 23.8403 10.1658 23.7371 10.289 23.6079L16.0033 17.8936L21.7176 23.6079C21.8408 23.7371 21.9887 23.8403 22.1524 23.9115C22.3161 23.9828 22.4924 24.0205 22.671 24.0226C22.8495 24.0247 23.0267 23.9911 23.192 23.9238C23.3574 23.8564 23.5076 23.7567 23.6338 23.6304C23.7601 23.5042 23.8598 23.354 23.9272 23.1886C23.9945 23.0232 24.0282 22.8461 24.0261 22.6676C24.024 22.489 23.9862 22.3127 23.915 22.149C23.8437 21.9853 23.7405 21.8374 23.6113 21.7142L17.897 15.9999Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_4141_2563">
    <rect width="16" height="16" fill="white" transform="translate(8 8)"/>
    </clipPath>
    </defs>
  </svg>
)

const ArrowKeyboard = ({ size = 10, color = '#000' }) => {
  return (
    <svg
      width={size}
      height={size / 0.7}
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.15514 0L0 1.92314L5.68961 7L0 12.0769L2.15514 14L10 7L2.15514 0Z"
        fill={color}
      />
    </svg>
  )
}

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
      <path d="M7.36925 11.2507L11.9228 14L10.7135 8.82L14.7385 5.334L9.4395 4.886L7.36925 0L5.29725 4.886L0 5.334L4.025 8.82L2.814 14L7.36925 11.2507Z" fill="#F8CC5D"/>
  </svg>
)

const CurvedArrowIcon = ({height = 84, width = 36}) => (
  <svg width={width} height={height} viewBox="0 0 36 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.21095 2C-0.405493 17.4113 -4.1107 54.7792 34 80.961M34 80.961L32.5113 74.2078M34 80.961L27.0527 82" stroke="#DB2828" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export {
  LocationIcon,
  ArrowDown,
  CutleryIcon,
  PlaneIcon,
  BedIcon,
  CheckmarkCircle,
  PlayIconRounded,
  CloseIcon,
  Arrow,
  BookIcon,
  OpenBookIcon,
  EmailIcon,
  Checkbox,
  ChatBubbleIcon,
  RewindIcon,
  CloseCirlce,
  CloseIconStroke,
  ArrowKeyboard,
  StarIcon,
  CurvedArrowIcon
}
